let mockedOut = false;

export function mockOutEvidently() {
	mockedOut = true;
}

function evidentlyIsSupported() {
	return typeof fetch !== 'undefined' && typeof Request !== 'undefined' && typeof URLSearchParams !== 'undefined';
}

export function evidentlyIsMockedOut() {
	return !evidentlyIsSupported() || mockedOut;
}
